import { ITEM_AVAILABILITY_STATUS, STATUS_TO_BOOLEANS } from 'features/Sku/Items/SkuItems.constants';

// Not getItemAvailabilityStatus: that returns null unless the entity is published, and resolves
// "indefinitely" from partnerState, which the modifier contract never sends.
export const getModifierAvailabilityStatus = modifier => {
  if (modifier?.enabled === false) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY;
  if (modifier?.soldOut === true) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY;
  return ITEM_AVAILABILITY_STATUS.AVAILABLE;
};

export const toModifierAvailability = status => {
  const { enabled, soldOut } = STATUS_TO_BOOLEANS[status] || STATUS_TO_BOOLEANS[ITEM_AVAILABILITY_STATUS.AVAILABLE];
  return { enabled, soldOut };
};
